const DEVTOOLS_SOURCE = 'autolist-devtools';

export function sendConfig(config: any): void {
  window.postMessage(
    {
      name: 'config',
      payload: config.toJSON(),
      source: DEVTOOLS_SOURCE,
    },
    '*'
  );
}

export function sendUser(user: any): void {
  window.postMessage(
    {
      name: 'user',
      payload: user,
      source: DEVTOOLS_SOURCE,
    },
    '*'
  );
}
